import { injectable } from 'inversify';

export interface EkomiSummary {
    rating: number;
    reviews: number;
    url: string;
    name: string;
}

@injectable()
export class Ekomi {

    private summaries = new Map<number, EkomiSummary>([
        // [1, { rating: 1, reviews: 100, url: '', name: '' }],
        // [2, { rating: 1.10, reviews: 100, url: '', name: '' }],
        // [3, { rating: 1.6, reviews: 100, url: '', name: '' }],
        // [4, { rating: 2.5, reviews: 100, url: '', name: '' }],
        // [5, { rating: 3.3, reviews: 100, url: '', name: '' }],
        // [6, { rating: 3.7, reviews: 100, url: '', name: '' }],
    ]);

    async get(id: number | null): Promise<EkomiSummary | void> {
        if (null === id || isNaN(id)) {
            return;
        }
        try {
            if (this.summaries.has(id)) {
                return this.summaries.get(id);
            }
            const result = await fetch(`https://smart-widget-assets.ekomiapps.de/data_files/json/${id}_seller_summary.json`);
            const data = await result.json();
            const summary = {
                name: data.your_company_name,
                rating: parseFloat(data.rating),
                reviews: data.total_reviews,
                url: data.ekomi_certificate_seo,
            };
            this.summaries.set(id, summary);
            return summary;
        } catch (err) {
            console.error(err);
        }
    }
}
